import axios from 'axios';
import { API_URL } from '../config/api.config';

const getAuthInfo = () => {
    const garageId = JSON.parse(localStorage.getItem('user') || '{}')._id || ''
    const token = localStorage.getItem('token');
    return { garageId, token };
};
const createAuthAxios = () => {
    const { token } = getAuthInfo();
    return axios.create({
        baseURL: API_URL,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};
const authAxios = createAuthAxios()

export const mobileUserService = {
    async validateUser(token: any) {
        try {
            const response = await authAxios.get(`/users/verify-email/${token}`);
            console.log("details" ,response.data);
            return response.data;
        }
        catch (error) {
            throw error;
        }
    }
};